@if (paymentDetails && details) {
    <div class="row mb-4">
        <app-details-header>
            <span class="my-3"
                ><strong>{{ companyName }} Customer reference</strong></span
            >
        </app-details-header>
        @for (detail of details; let detailIndex = $index; track detailIndex) {
            @if (detail.show) {
                <app-details-field class="col-12 col-md-4" [label]="detail.label ?? ''" [value]="detail.value" />
            }
        }
        @for (field of dynamicFields; let fieldIndex = $index; track fieldIndex) {
            <app-details-field class="col-12 col-md-4" [label]="field.label ?? ''" [value]="field.value" />
        }
        @if (files.length) {
            <app-files-container [filesPath]="files" [title]="fileName" />
        }
    </div>
}
